import StartWithoutReg from './StartWithoutReg';

export default StartWithoutReg;
